export default "/server-build/img/ea11cfd8af6a6843fabe9499d6822b74.png";